import { FC } from "react";
import styles from "./SkeletonCheckboxLoader.module.scss";

export const SkeletonCheckboxLoader: FC = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}></div>
            <div className={styles.grid}>
                {Array.from({ length: 24 }).map((_, index) => (
                    <div key={index} className={styles.item}>
                        <div className={styles.checkbox}></div>
                        <div className={styles.label}></div>
                    </div>
                ))}
            </div>
        </div>
    );
};